import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";
import { agency, legal, navLinks, services } from "../mock";

export default function Footer() {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer className="bg-[#2b2620] text-white/80">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <p className="font-serif text-2xl font-semibold tracking-[0.15em] text-white">SOLÈS IMMO</p>
          <p className="text-xs tracking-[0.3em] text-accent mt-1">BOULOGNE-BILLANCOURT</p>
          <p className="mt-5 text-sm leading-relaxed text-white/70">
            Agence immobilière affiliée FNAIM. Acheter, louer, vendre et gérer, rien que pour vous.
          </p>
          <div className="mt-5 inline-flex items-center gap-2 border border-white/20 rounded-md px-3 py-1.5">
            <span className="font-serif font-bold text-accent tracking-wider">FNAIM</span>
            <span className="text-[10px] text-white/60 leading-tight">Fédération Nationale<br/>de l'Immobilier</span>
          </div>
        </div>

        <div>
          <h4 className="text-white font-medium mb-4 tracking-wide">Navigation</h4>
          <ul className="space-y-2.5 text-sm">
            {navLinks.map((l) => (
              <li key={l.href}>
                <button onClick={() => go(l.href)} className="hover:text-accent transition-colors">{l.label}</button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-medium mb-4 tracking-wide">Nos services</h4>
          <ul className="space-y-2.5 text-sm">
            {services.map((s) => (
              <li key={s.id}>
                <button onClick={() => go("#services")} className="hover:text-accent transition-colors">{s.title}</button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-medium mb-4 tracking-wide">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2.5">
              <MapPin className="h-4 w-4 mt-0.5 text-accent shrink-0" />
              <span>{agency.address}<br/>{agency.zip}</span>
            </li>
            <li className="flex items-center gap-2.5">
              <Phone className="h-4 w-4 text-accent shrink-0" />
              <a href={`tel:${agency.phoneHref}`} className="hover:text-accent transition-colors">{agency.phone}</a>
            </li>
            <li className="flex items-center gap-2.5">
              <Mail className="h-4 w-4 text-accent shrink-0" />
              <a href={`mailto:${agency.email}`} className="hover:text-accent transition-colors">{agency.email}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 text-[11px] text-white/50 leading-relaxed">
          <p>{legal.fnaim}</p>
          <p className="mt-1">{legal.carte} — {legal.garanti}</p>
          <p className="mt-3 text-white/60">{legal.copyright}</p>
        </div>
      </div>
    </footer>
  );
}
